import { HttpService, Repository, RepositoryBase, TaggedUrl, Tags, Weaver } from '@skylab-shared/core';
import { InventoryModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { InventoryBO } from './inventory.bo';


@Repository({
    boType: InventoryBO,
    apiController: TaggedUrl.join('inventory', [Tags.Api])
})
export class InventoryRepositoryBase extends RepositoryBase<InventoryBO, InventoryModel> {
    public constructor(
        private readonly weaver: Weaver,
        http: HttpService,
    ) {
        super(http);
    }

    protected createBO(): InventoryBO {
        return new InventoryBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: InventoryModel): Promise<any> {
        return {
            version: model.version,
            name: model.name,
            symbol: model.symbol,
            id: model.id
        };
    }

    protected async fromPlainObjectAsync(item: any): Promise<InventoryModel> {
        return new InventoryModel(pickBy<InventoryModel>({
            version: item.version,
            name: item.name,
            symbol: item.symbol,
            id: item.id
        }, val => val !== void 0));
    }

    //#endregion
}
